import React from 'react';
import styled from 'styled-components';
import { PanelLeftClose, PanelLeft } from 'lucide-react';

import { semanticColors, colorTokens } from '@/common/styles/colorTokens';
import { NavHeaderProps } from '../config/types';

// 공통 로고 사용
import logo from '@/common/assets/logo/factsheet_logo.png';
import logoIcon from '@/common/assets/logo/factsheet_icon.png';
import config from '@/config';

// 스타일 컴포넌트 정의
const HeaderContainer = styled.div<{ $isCollapsed: boolean }>`
  width: 100%;
  height: 64px;
  min-height: 64px;
  border-bottom: 1px solid ${semanticColors.border.primary};
  display: flex;
  align-items: center;
  justify-content: ${props => props.$isCollapsed ? 'center' : 'space-between'};
  padding: ${props => props.$isCollapsed ? '0' : '0 12px 0 24px'};
  background: white;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Tag = styled.span<{ $isCollapsed?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.$isCollapsed ? '1px 4px' : '2px 6px'};
  background: ${colorTokens.brand[100]};
  color: ${colorTokens.brand[700]};
  border: 1px solid ${colorTokens.brand[300]};
  border-radius: 4px;
  font-size: ${props => props.$isCollapsed ? '8px' : '10px'};
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 1;
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  color: ${colorTokens.gray[400]};
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    background: ${colorTokens.gray[100]};
    color: ${colorTokens.gray[900]};
  }
`;

const NavHeader: React.FC<NavHeaderProps> = ({ isCollapsed = false, onToggle }) => {
  const environment = config.environment;
  const isDev = environment !== 'production';

  return (
    <HeaderContainer $isCollapsed={isCollapsed}>
      {isCollapsed ? (
        <div 
          onClick={onToggle} 
          style={{ 
            cursor: 'pointer', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            gap: '2px'
          }}
          title="네비게이션 펼치기"
        >
          <img src={logoIcon} alt="icon" style={{ width: '28px', height: '28px' }} />
          {isDev && (
            <Tag $isCollapsed>Dev</Tag>
          )}
        </div>
      ) : (
        <>
          <LogoSection>
            <img
              src={logo}
              alt="logo"
              style={{
                width: '130px',
                height: 'auto',
                userSelect: 'none',
                pointerEvents: 'none',
              }}
              draggable={false}
            />
            {isDev && <Tag>Dev</Tag>}
          </LogoSection>
          <ToggleButton onClick={onToggle} title="네비게이션 접기">
            <PanelLeftClose size={18} />
          </ToggleButton>
        </>
      )}
    </HeaderContainer>
  );
};

export default NavHeader;

